module.exports = __webpack_public_path__ + "img/cloak.432a733b.svg";